import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import EventBus from '@/eventBus';

import AdminSettingsSignUpStrategy from '@/views/admin/Settings/Authentications/AdminSettingsSignUpStrategy.vue';
import { get } from 'lodash';
import store from './store';

import NotFound from './components/Pages/user/NotFound.vue';
import Suspended from './views/signup/Suspended.vue';
import PermanentBan from './views/signup/PermanentBan.vue';

// Public
import MainPublic from './components/Pages/public/MainPublic.vue';
import Login from './components/Pages/public/Login.vue';
import LogoutAction from './components/Templates/login/LogoutAction.vue';

import CoViewPublicEvent from './components/Pages/user/event/CoViewPublicEvent.vue';
import CoViewPublicEventList from './components/Pages/user/event/CoViewPublicEventList.vue';

// Embed (Public)
import MainEmbed from './components/Pages/embed/MainEmbed.vue';
import EmbedEventList from './components/Pages/embed/EmbedEventList.vue';

// SignUp
import EmailConfirmation from './components/Pages/public/EmailConfirmation.vue';
import Signup from './components/Pages/public/Signup.vue';
import RegisterV2 from './views/signup/RegisterV2.vue';
import SignUpSuccess from './views/signup/Success.vue';
import ResetPassword from './views/signup/ResetPassword.vue';
import ForceResetPassword from './views/signup/ForcePasswordReset.vue';
import SetNewPassword from './views/signup/SetNewPassword.vue';

// Plans
import Plans from './views/signup/Plans.vue';
import PlanDetails from './views/signup/PlanDetails.vue';

// Events
import ViewEvent from './components/Pages/user/event/co-view-event.vue';
import ViewEventParticipants from './components/Pages/user/event/co-view-event-participants.vue';
import CreateEvent from './components/Pages/user/event/CoEventCreate.vue';
import MyEvents from './components/Pages/user/event/CoMyEvents.vue';
import ListEvents from './components/Pages/user/event/co-list-events.vue';

// Users
import ViewProfile from './components/Pages/user/ViewProfile.vue';
import Community from './views/users/Community.vue';

// routes for my profile
import CoMyBookings from './components/Pages/user/CoMyBookings.vue';

// Page
import CreatePage from './views/projects/CreateProject.vue';
import CoViewPage from './components/Pages/user/channel/page/co-view-page.vue';

// Jobs
import ViewJob from './views/jobs/ViewJob.vue';
import CreateJob from './views/jobs/CreateJob.vue';
import EditJob from './views/jobs/EditJob.vue';
import CoMarketItems from './components/Pages/user/market/co-market-items.vue';

// Chat
import NewMessage from './views/chat/NewMessage.vue';
import Messenger from './views/chat/Messenger.vue';
import Chat from './views/chat/Chat.vue';
import EditChat from './views/chat/EditChat.vue';

// Legal
import LegalBase from './views/legal/LegalBase.vue';
import PrivacyPolicy from './views/legal/PrivacyPolicy.vue';
import TermsAndConditions from './views/legal/TermsAndConditions.vue';
import AccessibilityPolicy from './views/legal/AccessibilityPolicy.vue';
import PurchaseCancellationPolicy from './views/legal/PurchaseCancellationPolicy.vue';
import RightOfWithdrawal from './views/legal/RightOfWithdrawal.vue';

// Misc
import Notifications from '@/components/Pages/user/Notifications.vue';

// Booking
import BookingCalendar from './views/booking/BookingCalendar.vue';

// General
import Search from './views/general/Search.vue';
import Feed from './components/Pages/user/feed/co-feed.vue';
import UserMain from './components/Pages/user/UserMain.vue';
import Main from './views/general/Main.vue';

// Channels and Pages
import CoChannelList from './components/Pages/user/channel/co-channel-list.vue';
import CoMyPages from './components/Pages/user/channel/page/co-my-pages.vue';
import CoChannelPages from './components/Pages/user/channel/page/co-channel-pages.vue';

// Posts
import SinglePost from './components/Pages/user/feed/co-single-post.vue';

// Welcome checklist
import CoWelcomePage from './components/Pages/user/CoWelcomePage.vue';

// Admin
import Admin from './views/admin/Admin.vue';

import AdminSpaceLocations from './components/Pages/admin/settings/Locations.vue';
import AdminSpaceAdministrators from './components/Pages/admin/settings/Administrators.vue';

import AdminSetupJavaScript from './views/admin/Setup/Javascript.vue';
import AdminSetupCustomization from './views/admin/Setup/Customization.vue';

import AdminSetupDomain from './components/Pages/admin/settings/Domain.vue';

import AdminSettingsFeatures from './views/admin/Settings/Features.vue';

import CoAdminMembersPlan from './components/Pages/admin/members/co-admin-members-plan/CoAdminMembersPlan.vue';
import CoAdminMembersPlanCreate from './components/Pages/admin/members/co-admin-members-plan/CoAdminMembersPlanCreate.vue';
import CoAdminMembersBase from './components/Pages/admin/members/co-admin-members-base/CoAdminMembersBase.vue';
import CoAdminMembersPlanUpdate from './components/Pages/admin/members/co-admin-members-plan/CoAdminMembersPlanUpdate.vue';
import CoAdminMembersBulkCreate from './components/Pages/admin/members/co-admin-members-bulk-create/CoAdminMembersBulkCreate.vue';
import CoAdminEventsList from './components/Pages/admin/events/CoAdminEventsList.vue';

import AdminMembersList from './views/admin/Community/Members/Members.vue';
import InvitedUsersList from './views/admin/Community/Members/InvitedUsers.vue';
import AdminMembersCustomFieldsPage from './components/Pages/admin/members/custom-fields/CustomFields.vue';
import AdminMemberUpgrades from './views/admin/Community/Members/MemberUpgrades.vue';
import MemberAccountV2 from './views/admin/Community/Members/MemberAccountV2.vue';
import MemberAccountTimePass from './views/admin/Community/Members/TimePass/MemberAccountTimePass.vue';
import MemberInvoices from './views/admin/Community/Members/MemberInvoices.vue';
import MemberBookings from './components/Pages/admin/members/bookings/CoUserBookings.vue';

import AdminBookings from './views/admin/Booking/Bookings.vue';
import AdminBookingCategories from './views/admin/Booking/BookingCategories.vue';
import AdminCreateBookingCategory from './views/admin/Booking/CreateBookingCategory.vue';
import AdminEditBookingCategory from './views/admin/Booking/EditBookingCategory.vue';
import AdminBookingStatistics from './views/admin/Booking/BookingStatistics.vue';

import AdminResources from './views/admin/Booking/BookinResources.vue';
import AdminBookingResourceCreateEdit from './components/Pages/admin/bookings/CoAdminBookingResourceCreateEdit.vue';

import AdminEventTypes from './views/admin/Event/Event-types.vue';

// Pages and Channels
import AdminPages from './views/admin/Pages/Pages.vue';
import AdminSettingsFeaturesChannels from './views/admin/Pages/Channels.vue';

import AdminAccount from './views/admin/Setup/Account.vue';

// Statistics
import AdminStatisticsBase from './views/admin/Statistics/Base.vue';
import AdminStatisticsGeneral from './views/admin/Statistics/Dashboard.vue';
import AdminStatisticsCheckins from './views/admin/Statistics/Checkins.vue';
import AdminStatisticsRevenue from './views/admin/Statistics/Revenue.vue';

// Monetization
import AdminMonetizationBase from './views/admin/Monetization/Base.vue';
import AdminMonetizationMenu from './views/admin/Monetization/Menu.vue';

// Access
import AdminCoDoorsNKeysBase from '@/components/Pages/admin/doorsnkeys/CoDoorsNKeysBase.vue';
import AdminDoorsNKeysMenu from '@/components/Pages/admin/doorsnkeys/CoDoorsNKeysMenu.vue';
import AdminAccessLocksList from '@/components/Pages/admin/doorsnkeys/doors/CoDoorList.vue';
import AdminAccessPoliciesList from '@/components/Pages/admin/doorsnkeys/policy/CoAccessPolicyList.vue';
import AdminAcccesKeyList from '@/components/Pages/admin/doorsnkeys/key/CoKeyList.vue';

// Payment
import AdminPaymentsBase from './views/admin/Monetization/Payments/Base.vue';
import AdminPayments from './views/admin/Monetization/Payments/Payments.vue';
import AdminPaymentsStripe from './views/admin/Monetization/Payments/Stripe.vue';
import AdminPaymentsCurrency from './views/admin/Monetization/Payments/Currency.vue';

// PaymentMethods
import AdminPaymentMethods from './views/admin/Monetization/Payments/PaymentMethods.vue';

// Tax Rates
import AdminTaxRateBase from './views/admin/Monetization/Payments/TaxRate/Base.vue';
import AdminCreateTaxRate from './views/admin/Monetization/Payments/TaxRate/Create.vue';
import AdminListTaxRates from './views/admin/Monetization/Payments/TaxRate/List.vue';
import AdminEditTaxRate from './views/admin/Monetization/Payments/TaxRate/Edit.vue';

// Plans
import AdminPlanBase from './views/admin/Monetization/Plans/PlanBase.vue';
import AdminListPlans from './views/admin/Monetization/Plans/Plans.vue';
import AdminCreatePlan from './views/admin/Monetization/Plans/Create.vue';

import AdminEditPlan from './views/admin/Monetization/Plans/Edit.vue';

// Plan upgrades
import AdminUpgradesBase from './views/admin/Monetization/PlanUpgrades/UpgradeBase.vue';
import AdminListPlanUpgrades from './views/admin/Monetization/PlanUpgrades/List.vue';
import AdminCreatePlanUpgrade from './views/admin/Monetization/PlanUpgrades/Create.vue';
import AdminEditPlanUpgrade from './views/admin/Monetization/PlanUpgrades/Edit.vue';
import AdminViewPlanUpgrade from './views/admin/Monetization/PlanUpgrades/View.vue';

// Time Passes
import AdminTimepassesBase from './views/admin/Monetization/Timepasses/AdminTimepassesBase.vue';
import AdminListTimepasses from './views/admin/Monetization/Timepasses/List.vue';
import AdminViewTimepass from './views/admin/Monetization/Timepasses/View.vue';
import AdminEditTimepass from './views/admin/Monetization/Timepasses/Edit.vue';
import AdminCreateTimepass from './views/admin/Monetization/Timepasses/Create.vue';

// Download File
import DownloadFile from './components/Pages/user/DownloadFile.vue';

// Settings
import AdminSettingsBase from './views/admin/Settings/Base.vue';
import AdminSettingsMenu from './views/admin/Settings/SettingsMenu.vue';

// Integrations
import AdminIntegrationsBase from './views/admin/Settings/Integrations/Base.vue';
import AdminIntegrations from './views/admin/Settings/Integrations/IntegrationsMenu.vue';
import AdminIntegrationsZapier from './views/admin/Settings/Integrations/Zapier.vue';
import AdminIntegrationsGoogleCalendar from './views/admin/Settings/Integrations/GoogleCalendar.vue';
import AdminIntegrationsNuki from './views/admin/Settings/Integrations/Nuki.vue';
import AdminIntegrationsTheEventCalendar from './views/admin/Settings/Integrations/TheEventCalendar.vue';

// Permissions
import AdminSettingsPermissions from './components/Pages/admin/settings/co-permissions/CoPermissions.vue';

// Agreements & Compliance
import AdminSettingsLegalAndCompliance from './views/admin/Settings/LegalAndCompliance/LegalAndCompliance.vue';
import AdminSettingsPrivacyPolicy from './views/admin/Settings/PrivacyPolicy.vue';
import AdminSettingsTermsAndConditions from './views/admin/Settings/TermsAndConditions.vue';
import AdminAccessibilityPolicy from './views/admin/Settings/AccessibilityPolicy.vue';

// Members settings
import AdminSettingsMemberSettings from './views/admin/Settings/CustomerSettings.vue';

// General
import AdminSettingsGeneral from './views/admin/Settings/General.vue';

// User Account
import Account from './views/account/Account.vue';
import GeneralAccountSettings from './views/account/GeneralAccountSettings.vue';
// import NotificationPreferences from './views/account/NotificationPreferences.vue';
import NotificationPreferences from './components/Pages/user/account/co-notifications-preferences.vue';
import MembershipPlanChangeList from './components/Pages/user/account/co-membership-plan-change-list.vue';
import ChangePlanCheckout from './views/account/plans/ChangePlanCheckout.vue';
import CurrentPlanView from './views/account/plans/CurrentPlanView.vue';
import PlanViewDetails from './views/account/plans/PlanViewDetails.vue';
import TimepassOverview from './views/account/time-passes/Overview.vue';
import BuyPassDetails from './views/account/time-passes/BuyPassProcess.vue';
import CoPaymentMethods from './components/Pages/user/account/co-payment-methods.vue';
import Invoices from './views/account/Invoices.vue';
import NewPaymentMethod from './views/account/NewPaymentMethod.vue';

import AdminAuthenticationsBase from './views/admin/Settings/Authentications/Base.vue';
import AdminAuthentications from './views/admin/Settings/Authentications/Menu.vue';
import AdminAuthenticationsSignUp from './views/admin/Settings/Authentications/SignUp.vue';
import AdminAuthenticationsLogin from './views/admin/Settings/Authentications/Login.vue';
import AdminAuthenticationsProviders from './views/admin/Settings/Authentications/Providers.vue';
import AdminAuthenticationsProviderEdit from './views/admin/Settings/Authentications/ProviderEditCreate.vue';
import OAuth2Callback from './views/auth_methods/OAuth2Callback.vue';

Vue.use(Router);

/*
ifAuthenticated
router method returning the authentication status of user and redirecting to
login if valid session does not exist
*/
const ifAuthenticated = async (to, from, next) => {
    const continueAuthenticatedNavigation = () => {
        if (to.query.m === 'mobile') {
            store.commit('SET_IS_IN_MOBILE', true);
        } else if (to.query.m === 'desktop') {
            store.commit('SET_IS_IN_MOBILE', false);
        }
        // set mobile app version
        if (to.query.appversion) {
            store.commit('SET_MOBILE_APP_VERSION', to.query.appversion);
        }
        next();
    };

    // Startup normally resolves the BFF session before this guard runs.
    if (store.state.auth && store.state.auth.authenticated) {
        continueAuthenticatedNavigation();
        return;
    }

    try {
        // A valid BFF cookie can become available after startup (for example, after a restored browser session).
        // Revalidate it and hydrate the user before redirecting a protected deep link to login.
        const response = await fetch('/bff/session', { credentials: 'include' });
        const session = response.ok ? await response.json() : null;

        if (session && session.authenticated) {
            await store.dispatch('getMe');
            store.commit('SET_AUTH_STATE', { authenticated: true, session });
            continueAuthenticatedNavigation();
            return;
        }
    } catch (error) {
        // Preserve the existing unauthenticated and public-event fallback behavior when revalidation fails.
    }

    // if to contains /event/ then try to get the event as public
    // and show the event page if it exists and is public
    // otherwise redirect to login with the current path
    if (to.path.includes('/event/') || to.path.includes('/events/')) {
        ensureSpaceSettingsLoaded().then((space) => {
            if (space?.EventsOff) {
                next('/not-found/event');
                return;
            }

            const eventSlug = to.path.split('/').pop();
            axios({
                method: 'GET',
                url: `/public/event/${eventSlug}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response.data && response.data.Slug) {
                        // if event is public, show the event page /public/event/:slug
                        next({
                            path: `/public/event/${eventSlug}`,
                        });
                    } else {
                        next({
                            path: '/login',
                            query: { redirect: to.fullPath.replace('/public', '') },
                        });
                    }
                })
                .catch(() => {
                    next({
                        path: '/login',
                        query: { redirect: to.fullPath.replace('/public', '') },
                    });
                });
        });

        return;
    }

    if (to.fullPath === '/') {
        next({
            path: '/login',
            query: { redirect: '/' },
        });
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath },
        });
    }
};

const ifTeamMember = async (to, from, next) => {
    const redirectToLogin = () =>
        next({
            path: '/login',
            query: { redirect: to.fullPath },
        });

    if (!store.getters.isAuthenticated) {
        redirectToLogin();
        return;
    }

    try {
        // A restored BFF session does not hydrate the persisted user, so permissions must be loaded before access is checked.
        await store.dispatch('getMe');
    } catch (error) {
        redirectToLogin();
        return;
    }

    if (!store.state.me.Permissions || !store.state.me.Permissions.includes('space_admin')) {
        next('/');
        return;
    }

    if (store.state.isInMobile) {
        const queryParam = {
            ...to.query,
            m: 'mobile',
            t: String(new Date().getTime()),
            openinbrowser: `${to.path}?t=${new Date().getTime()}`,
        };
        next({ path: '/feed', query: queryParam });
        return;
    }

    next();
};

const logPageView = (from, to) => {
    if (!to || typeof to !== 'object') {
        // missing or wrong type of routerObj
        return;
    }

    let data;
    data = {
        full_path: to.fullPath,
        parameters: {
            ...get(to, 'query', {}),
            apptype: get(store, 'state.isInMobile', false) ? 'mobile-app' : 'web-app',
            language: get(window, 'navigator.language', 'unknown'),
            platform: get(window, 'navigator.platform', 'unknown'),
            useragent: get(window, 'navigator.userAgent', 'unknown'),
            referrer: get(from, 'fullPath', 'unknown'),
        },
    };
    data = JSON.stringify(data);
    let url = '/public/page-visit';

    if (store?.getters?.isAuthenticated) {
        url = '/me/page-visit';
    }

    axios({
        method: 'POST',
        url,
        data,
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            // console.log("Page view logging was successfull", routerObj);
        })
        .catch((error) => {
            // console.log("Page view logging failed");
        });
};

function hasQueryParams(route) {
    return !!Object.keys(route.query).length;
}

const redirectorToMyProfile = (to, from, next) => {
    next('/profile/me');
};

const redirectorTo404 = (to, from, next) => {
    next('/error404');
};

const ensureSpaceSettingsLoaded = async (featureFlag = 'EventsOff') => {
    if (typeof get(store, `state.space.${featureFlag}`) === 'boolean') {
        return store.state.space;
    }

    try {
        await store.dispatch('getSpaceSettings');
    } catch (error) {
        return store.state.space || {};
    }

    return store.state.space || {};
};

const redirectToEventNotFoundIfDisabled = (to, from, next) => {
    ensureSpaceSettingsLoaded().then((space) => {
        if (space?.EventsOff) {
            next('/not-found/event');
            return;
        }

        next();
    });
};

const redirectToPageNotFoundIfDisabled = (to, from, next) => {
    ensureSpaceSettingsLoaded('PagesOff').then((space) => {
        // PagesOff removes member-facing pages and channels, including bookmarked URLs.
        if (space?.PagesOff) {
            next('/error404');
            return;
        }

        next();
    });
};

const redirectToBookingNotFoundIfDisabled = (to, from, next) => {
    ensureSpaceSettingsLoaded('BookingOn').then((space) => {
        next(space?.BookingOn ? undefined : '/error404');
    });
};

const redirectToMarketNotFoundIfDisabled = (to, from, next) => {
    ensureSpaceSettingsLoaded('MarkeplaceOn').then((space) => {
        next(space?.MarkeplaceOn ? undefined : '/error404');
    });
};

// Add new function to check user limit
const checkUserLimit = async () => {
    try {
        const response = await axios({
            method: 'GET',
            url: '/space/limits',
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return get(response, 'data.UserLimitReached', false);
    } catch (error) {
        console.error('Failed to check user limit:', error);
        return false;
    }
};

const checkIfAllowedToSingup = (to, from, next) => {
    const inviteId = to.query.invite;
    if (inviteId) {
        store.commit('SET_INVITE_ID', inviteId);
    } else {
        store.commit('SET_INVITE_ID', null);
        store.commit('SET_INVITE', null);
    }

    checkUserLimit().then((isMaxUsers) => {
        if (isMaxUsers) {
            // Redirect to login with max users reached message
            next({
                path: '/login',
                query: { registrationsAreClosed: 'true' },
            });
            return;
        }

        // convert "to" to URL string
        const toStr = to.fullPath;

        // get signup settings
        // if space is invite-only, check if the invite is valid and allow signup only if it is valid
        // if space is not invite-only, allow signup directly
        store
            .dispatch('getSignupSettings')
            .then((response) => {
                const signupSettings = response.data;
                if (signupSettings.signUpStrategy === 'invite-only') {
                    // wait for the invite to be validated before allowing signup
                    store
                        .dispatch('validateSignupInvite', inviteId)
                        .then(() => {
                            // checkif billing is turned on
                            axios({
                                method: 'GET',
                                url: '/space/plan/list',
                                withCredentials: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            })
                                .then((plansListResponse) => {
                                    if (get(plansListResponse, 'data', []).length > 0) {
                                        next({ path: '/plans', query: { invite: inviteId } });
                                    } else {
                                        // allow signup directly if billing is turned off and space is not invite-only
                                        next();
                                    }
                                })
                                .catch((error) => {
                                    if (get(error, 'response.status', null) === 404) {
                                        next();
                                    } else {
                                        // allow signup directly if billing is turned off and space is not invite-only
                                        EventBus.$emit('ERROR', {
                                            Message:
                                                'Failed to fetch sign up settings. Please try again later. If the problem persists, please contact support. E001',
                                        });

                                        next({
                                            path: '/login',
                                        });
                                    }
                                });
                        })
                        .catch(() => {
                            // if invite is not valid, redirect to login page
                            EventBus.$emit('ERROR', {
                                Message: 'The invite link is invalid.',
                            });

                            next({
                                path: '/login',
                                query: { invalidInviteLink: toStr },
                            });
                        });
                } else {
                    // checkif billing is turned on
                    axios({
                        method: 'GET',
                        url: '/space/plan/list',
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then((plansListResponse) => {
                            if (get(plansListResponse, 'data', []).length > 0) {
                                next({ path: '/plans', query: { invite: inviteId } });
                            } else {
                                // allow signup directly if billing is turned off and space is not invite-only
                                next();
                            }
                        })
                        .catch((error) => {
                            if (get(error, 'response.status', null) === 404) {
                                next();
                            } else {
                                EventBus.$emit('ERROR', {
                                    Message:
                                        'Failed to fetch sign up settings. Please try again later. If the problem persists, please contact support. E002',
                                });

                                next({
                                    path: '/login',
                                });
                            }
                        });
                }
            })
            .catch((error) => {
                // if error is 404, allow signup because it means that the space doesn't have signup settings yet, default to allowing signup
                if (get(error, 'response.status', null) === 404) {
                    // checkif billing is turned on
                    axios({
                        method: 'GET',
                        url: '/space/plan/list',
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then((plansListResponse) => {
                            if (get(plansListResponse, 'data', []).length > 0) {
                                next({ path: '/plans', query: { invite: inviteId } });
                            } else {
                                // allow signup directly if billing is turned off and space is not invite-only
                                next();
                            }
                        })
                        .catch((err) => {
                            if (get(err, 'response.status', null) === 404) {
                                next();
                            } else {
                                EventBus.$emit('ERROR', {
                                    Message:
                                        'Failed to get sign up settings. Please try again later. If the problem persists, please contact support. E003',
                                });

                                next({
                                    path: '/login',
                                });
                            }
                        });
                } else {
                    // if error is not 404, redirect to login page because we don't know if signup is allowed or not yet
                    // this is to prevent users from being able to signup when signup is not allowed
                    EventBus.$emit('ERROR', {
                        Message:
                            'Failed to get signup settings. Please try again later. If the problem persists, please contact support. E004',
                    });
                    next('/login');
                }
            });
    });
};

// checkIfInviteIsValidForPaid used to verify if invit in query or vues is valid
const checkIfInviteIsValidForPaid = (to, from, next) => {
    const inviteId = store.state.newMembership.InviteID || to.query.invite;

    if (inviteId) {
        store.commit('SET_INVITE_ID', inviteId);
    } else {
        store.commit('SET_INVITE_ID', null);
        store.commit('SET_INVITE', null);
    }

    checkUserLimit().then((isMaxUsers) => {
        if (isMaxUsers) {
            // Redirect to login with max users reached message
            next({
                path: '/login',
                query: { registrationsAreClosed: 'true' },
            });
            return;
        }
        // get signup settings
        // if space is invite-only, check if the invite is valid and allow signup only if it is valid
        // if space is not invite-only, allow signup directly
        store
            .dispatch('getSignupSettings')
            .then((response) => {
                const signupSettings = response.data;
                if (signupSettings.signUpStrategy === 'invite-only') {
                    // wait for the invite to be validated before allowing signup
                    store
                        .dispatch('validateSignupInvite', inviteId)
                        .then(() => {
                            next();
                        })
                        .catch(() => {
                            // if invite is not valid, redirect to login page
                            EventBus.$emit('ERROR', {
                                Message:
                                    'The invite link is invalid. Please contact the space admin for a new invite link.',
                            });
                            next('/login');
                        });
                } else {
                    next();
                }
            })
            .catch((error) => {
                console.log(error);
                // if error is not 404, redirect to login page because we don't know if signup is allowed or not yet
                // this is to prevent users from being able to signup when signup is not allowed
                EventBus.$emit('ERROR', {
                    Message:
                        'Failed to get signup settings. Please try again later. If the problem persists, please contact support. E005',
                });
                next('/login');
            });
    });
};

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            meta: {
                'og:image': store.state.space.LogoURL,
                Title: `${store.state.space.Name} Community Platform`,
                requiresAuth: true,
            },
            path: '/',
            alias: '/feed',
            component: Main,
            beforeEnter: ifAuthenticated,
            children: [
                {
                    path: '',
                    component: UserMain,
                    children: [
                        {
                            name: 'Timeline',
                            path: '',
                            component: Feed,
                        },
                        {
                            name: 'Welcome',
                            path: 'welcome',
                            component: CoWelcomePage,
                        },
                        {
                            // catch all 404 routing
                            // redirect all unresolved urls to dashboard
                            path: 'error404',
                            name: 'Error 404',
                            component: NotFound,
                        },
                        {
                            path: '/not-found/:contentType',
                            name: 'NotFound',
                            component: NotFound,
                        },
                        {
                            path: '/submit-job',
                            redirect: '/submit-market-item',
                        },

                        {
                            name: 'CreateMarketItem',
                            path: '/submit-market-item',
                            component: CreateJob,
                            beforeEnter: redirectToMarketNotFoundIfDisabled,
                        },

                        {
                            path: '/pages/create',
                            alias: '/create/page',
                            component: CreatePage,
                            beforeEnter: redirectToPageNotFoundIfDisabled,
                        },

                        {
                            name: 'Events',
                            path: '/events',
                            beforeEnter: redirectToEventNotFoundIfDisabled,
                            component: ListEvents,
                        },
                        {
                            name: 'Create event',
                            path: '/events/create',
                            beforeEnter: redirectToEventNotFoundIfDisabled,
                            component: CreateEvent,
                        },
                        {
                            path: '/events/:slug',
                            alias: '/event/:slug',
                            name: 'View Event',
                            beforeEnter: redirectToEventNotFoundIfDisabled,
                            component: ViewEvent,
                            meta: {
                                mainGridOptions: {
                                    hideRight: true,
                                    stretchCenter: true,
                                },
                            },
                        },
                        {
                            name: 'View Event Participants',
                            path: '/events/:slug/participants',
                            beforeEnter: redirectToEventNotFoundIfDisabled,
                            component: ViewEventParticipants,
                            meta: {
                                mainGridOptions: {
                                    hideRight: true,
                                    stretchCenter: true,
                                },
                            },
                        },
                        {
                            name: 'ChannelPage',
                            path: '/channels/:channelsSlug/:slug',
                            component: CoViewPage,
                            beforeEnter: redirectToPageNotFoundIfDisabled,
                            meta: {
                                mainGridOptions: {
                                    hideRight: true,
                                    stretchCenter: true,
                                },
                            },
                        },
                        {
                            path: '/project/:slug',
                            alias: '/page/:slug',
                            name: 'View Project',
                            component: CoViewPage,
                            beforeEnter: redirectToPageNotFoundIfDisabled,
                            meta: {
                                mainGridOptions: {
                                    hideRight: true,
                                    stretchCenter: true,
                                },
                            },
                        },
                        {
                            name: 'CoMyPages',
                            path: '/profile/my-pages',
                            component: CoMyPages,
                            beforeEnter: redirectToPageNotFoundIfDisabled,
                        },
                        {
                            name: 'MyEvents',
                            path: '/profile/my-events',
                            component: MyEvents,
                        },
                        {
                            path: '/profile/my-bookings',
                            name: 'MyBookings',
                            component: CoMyBookings,
                            beforeEnter: redirectToBookingNotFoundIfDisabled,
                            meta: {
                                mainGridOptions: {
                                    hideRight: true,
                                    stretchCenter: true,
                                },
                            },
                        },
                        {
                            path: '/profile/:slug',
                            name: 'Profile',
                            component: ViewProfile,
                            meta: {
                                mainGridOptions: {
                                    hideRight: true,
                                    stretchCenter: false,
                                    centerContent: true,
                                },
                            },
                        },
                        {
                            name: 'Market',
                            path: '/market',
                            alias: '/jobs',
                            component: CoMarketItems,
                            beforeEnter: redirectToMarketNotFoundIfDisabled,
                        },
                        {
                            name: 'Community',
                            path: '/community',
                            component: Community,
                        },

                        {
                            name: 'ChannelPages',
                            path: '/channels/:slug',
                            component: CoChannelPages,
                            beforeEnter: redirectToPageNotFoundIfDisabled,
                        },

                        {
                            path: '/messenger',
                            component: Messenger,
                            children: [
                                {
                                    name: 'EditChat',
                                    path: 'edit/:slug',
                                    component: EditChat,
                                },
                                {
                                    name: 'Chat',
                                    path: ':slug',
                                    component: Chat,
                                },
                                {
                                    name: 'NewMessage',
                                    path: '',
                                    component: NewMessage,
                                },
                            ],
                        },
                        {
                            name: 'Single Post View',
                            path: '/post/:slug',
                            alias: ['/project-update/:slug', '/event-as-post/:slug', '/page-as-post/:slug'],
                            component: SinglePost,
                        },
                        {
                            // TODO: this route will be removed after posts as market item publication is done
                            // permanently redirect to /post/:slug with date note to remove completely after 1-2 years
                            name: 'Market Item as Post View',
                            path: '/market-item-as-post/:slug',
                            alias: '/jobs/:slug', // TODO: check if alias is needed here and remove if not
                            component: SinglePost,
                            beforeEnter: redirectToMarketNotFoundIfDisabled,
                        },
                        {
                            path: '/post/edit/:slug',
                            redirect: '/post/:slug',
                        },
                        {
                            path: '/notifications',
                            name: 'Notifications',
                            component: Notifications,
                        },

                        {
                            name: 'search',
                            path: '/search',
                            alias: '/search/in-app',
                            component: Search,
                        },
                    ],
                },
                {
                    path: '/settings',
                    redirect: '/account',
                },
                {
                    path: '/settings/notifications',
                    redirect: '/account/notifications',
                },
                {
                    path: '/account',
                    name: 'Account',
                    component: Account,
                    children: [
                        {
                            path: 'notifications',
                            name: 'NotificationPreferences',
                            component: NotificationPreferences,
                        },
                        {
                            path: '',
                            name: 'GeneralAccountSettings',
                            component: GeneralAccountSettings,
                        },
                        {
                            path: 'plan/view/:ID',
                            name: 'PlanViewDetails',
                            component: PlanViewDetails,
                        },
                        {
                            path: 'plan/change/:ID',
                            name: 'ChangePlanCheckout',
                            component: ChangePlanCheckout,
                        },
                        {
                            path: 'plan/change',
                            name: 'MembershipPlanChangeList',
                            component: MembershipPlanChangeList,
                        },
                        {
                            path: 'plan',
                            name: 'CurrentUserPlanView',
                            component: CurrentPlanView,
                        },

                        {
                            path: 'billing/add-payment-method',
                            name: 'Add payment method',
                            component: NewPaymentMethod,
                        },
                        {
                            alias: 'billing',
                            path: 'billing/invoices',
                            name: 'Invoices',
                            component: Invoices,
                        },
                        {
                            path: 'billing/payment-methods',
                            name: 'Payment Methods',
                            component: CoPaymentMethods,
                        },
                        {
                            path: 'time-passes',
                            name: 'TimepassOverview',
                            component: TimepassOverview,
                        },
                        {
                            path: 'time-passes/buy/:ID',
                            name: 'BuyPassDetails',
                            component: BuyPassDetails,
                        },
                        {
                            path: '*',
                            redirect: '/account',
                        },
                    ],
                },
                {
                    name: 'Booking Calendar',
                    path: '/booking-calendar',
                    component: BookingCalendar,
                    beforeEnter: redirectToBookingNotFoundIfDisabled,
                },

                {
                    path: '/myprofile',
                    name: 'MyProfile',
                    beforeEnter: redirectorToMyProfile,
                },

                {
                    name: 'ChannelList',
                    path: '/channels',
                    component: CoChannelList,
                },
                {
                    path: '/market/:slug',
                    alias: '/job/:slug',
                    name: 'View Job',
                    component: ViewJob,
                    beforeEnter: redirectToMarketNotFoundIfDisabled,
                },
                {
                    path: '/market/edit/:slug',
                    alias: '/job/edit/:slug',
                    name: 'EditJob',
                    component: EditJob,
                    beforeEnter: redirectToMarketNotFoundIfDisabled,
                },
                {
                    path: '/download/:fileId',
                    name: 'DownloadFile',
                    component: DownloadFile,
                },
            ],
        },

        {
            path: '/admin',
            component: Admin,
            beforeEnter: ifTeamMember,
            children: [
                {
                    name: 'Space Administrators',
                    path: 'space/administrators',
                    redirect: 'community/administrators',
                },
                {
                    name: 'Space Locations',
                    path: 'space/locations',
                    component: AdminSpaceLocations,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.space',
                                to: '/admin/space/locations',
                            },
                            {
                                text: 'labels.locations',
                            },
                        ],
                    },
                },
                {
                    name: 'AdminAccount',
                    path: 'account',
                    component: AdminAccount,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.settings',
                                to: '/admin/settings',
                            },
                            {
                                text: 'labels.account',
                            },
                        ],
                    },
                },
                {
                    name: 'JavaScript',
                    path: 'setup/javascript',
                    component: AdminSetupJavaScript,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.settings',
                                to: '/admin/settings',
                            },
                            {
                                text: 'labels.javascript',
                            },
                        ],
                    },
                },
                {
                    path: 'setup/colors',
                    redirect: 'setup/customization',
                },

                {
                    path: 'setup/intro',
                    redirect: 'setup/customization',
                },
                {
                    path: 'setup/logo',
                    redirect: 'setup/customization',
                },
                {
                    name: 'customization',
                    path: 'setup/customization',
                    component: AdminSetupCustomization,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.settings',
                                to: '/admin/settings',
                            },
                            {
                                text: 'labels.customization',
                            },
                        ],
                    },
                },
                {
                    name: 'signup-strategy',
                    path: 'setup/signup-strategy',
                    component: AdminSettingsSignUpStrategy,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.settings',
                                to: '/admin/settings',
                            },
                            {
                                text: 'labels.authentication',
                                to: '/admin/settings/authentications',
                            },
                            {
                                text: 'labels.signupstrategy',
                            },
                        ],
                    },
                },
                {
                    name: 'Domain',
                    path: 'setup/domain',
                    component: AdminSetupDomain,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.settings',
                                to: '/admin/settings',
                            },
                            {
                                text: 'labels.domain',
                            },
                        ],
                    },
                },

                /**
                 * New Members routes
                 */
                {
                    path: 'member/:ID',
                    component: CoAdminMembersBase,
                    children: [
                        {
                            name: 'AdminMemberPlanUpdate',
                            path: 'plan/update',
                            component: CoAdminMembersPlanUpdate,
                        },
                        {
                            name: 'AdminMemberPlanCreate',
                            path: 'plan/create',
                            component: CoAdminMembersPlanCreate,
                        },
                        {
                            name: 'AdminMemberPlan',
                            path: 'plan',
                            component: CoAdminMembersPlan,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.members',
                                        to: '/admin/community/member/list',
                                    },
                                    {
                                        text: '{{username}}', // will be replaced with username from CoAdminMembersBase page
                                        to: '{{profile_url}}', // will be replaced with profile_url from CoAdminMembersBase page
                                    },
                                    {
                                        text: 'labels.plan',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Community Member Account Time Pass',
                            path: 'time-passes',
                            component: MemberAccountTimePass,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.members',
                                        to: '/admin/community/member/list',
                                    },
                                    {
                                        text: '{{username}}', // will be replaced with username from CoAdminMembersBase page
                                        to: '{{profile_url}}', // will be replaced with profile_url from CoAdminMembersBase page
                                    },
                                    {
                                        text: 'labels.timepasses',
                                    },
                                ],
                            },
                        },
                    ],
                },

                /**
                 * Community Members routes
                 */
                {
                    name: 'Community Members',
                    path: 'community/member/list',
                    component: AdminMembersList,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.members',
                            },
                        ],
                    },
                },
                {
                    name: 'Community Member Bulk Create',
                    path: 'community/member/create',
                    component: CoAdminMembersBulkCreate,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.members',
                                to: '/admin/community/member/list',
                            },
                            {
                                text: 'labels.bulkcreate',
                            },
                        ],
                    },
                },
                {
                    name: 'Community Member Upgrade List',
                    path: 'community/member/upgrades',
                    component: AdminMemberUpgrades,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.members',
                                to: '/admin/community/member/list',
                            },
                            {
                                text: 'labels.upgrades',
                            },
                        ],
                    },
                },
                {
                    name: 'Invited Users',
                    path: 'community/member/invitations',
                    component: InvitedUsersList,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.invited',
                            },
                        ],
                    },
                },
                {
                    name: 'Community Member Custom Fields',
                    path: 'community/member/custom-fields',
                    component: AdminMembersCustomFieldsPage,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.members',
                            },
                            {
                                text: 'labels.customfields',
                            },
                        ],
                    },
                },
                {
                    name: 'Community Member Account',
                    path: 'community/member/view/:ID',
                    component: MemberAccountV2,
                },
                {
                    name: 'Community Member Invoices',
                    path: 'community/member/invoices/:ID',
                    component: MemberInvoices,
                },
                {
                    name: 'Community Member Bookings',
                    path: 'community/member/bookings/:ID',
                    component: MemberBookings,
                },
                {
                    name: 'Community Member Account Purchase Time Pass',
                    path: 'community/member/time-passes/purchase/:ID',
                    component: MemberAccountTimePass,
                },
                {
                    name: 'Administrators',
                    path: 'community/administrators',
                    component: AdminSpaceAdministrators,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.administrators',
                            },
                        ],
                    },
                },
                /**
                 * Booking routes
                 */
                {
                    name: 'Booking calendar',
                    path: 'booking/calendar',
                    component: AdminBookings,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingcalendar',
                            },
                        ],
                    },
                },
                {
                    name: 'Booking categories',
                    path: 'booking/categories',
                    component: AdminBookingCategories,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingcategories',
                            },
                        ],
                    },
                },
                {
                    name: 'Create booking category',
                    path: 'booking/categories/create',
                    component: AdminCreateBookingCategory,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingcategories',
                                to: '/admin/booking/categories',
                            },
                            {
                                text: 'labels.create',
                            },
                        ],
                    },
                },
                {
                    name: 'Edit booking category',
                    path: 'booking/categories/edit/:id',
                    component: AdminEditBookingCategory,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingcategories',
                                to: '/admin/booking/categories',
                            },
                            {
                                text: 'labels.edit',
                            },
                        ],
                    },
                },
                {
                    name: 'Booking Statistics',
                    path: 'booking/statistics',
                    component: AdminBookingStatistics,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookings',
                                to: '/admin/booking/calendar',
                            },
                            {
                                text: 'labels.statistics',
                                to: '/admin/booking/statistics',
                            },
                        ],
                    },
                },
                {
                    name: 'Booking resources',
                    path: 'booking/resource',
                    component: AdminResources,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingresources',
                            },
                        ],
                    },
                },
                {
                    name: 'Create booking resource',
                    path: 'booking/resource/create',
                    component: AdminBookingResourceCreateEdit,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingresources',
                                to: '/admin/booking/resource',
                            },
                            {
                                text: 'labels.create',
                            },
                        ],
                    },
                },
                {
                    name: 'Edit booking resource',
                    path: 'booking/resource/edit/:id',
                    component: AdminBookingResourceCreateEdit,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.bookingresources',
                                to: '/admin/booking/resource',
                            },
                            {
                                text: 'labels.edit',
                            },
                        ],
                    },
                },
                {
                    name: 'Admin events',
                    path: 'event/list',
                    component: CoAdminEventsList,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.events',
                            },
                        ],
                    },
                },
                {
                    name: 'Event types',
                    path: 'event/types',
                    component: AdminEventTypes,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.eventtypes',
                            },
                        ],
                    },
                },
                {
                    name: 'Pages List',
                    path: 'pages/list',
                    component: AdminPages,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.channelspages',
                                to: '/admin/pages/list',
                            },
                            {
                                text: 'labels.pages',
                            },
                        ],
                    },
                },
                {
                    name: 'Channels',
                    path: 'pages/channels',
                    component: AdminSettingsFeaturesChannels,
                    meta: {
                        breadcrumbs: [
                            {
                                text: 'labels.manage',
                                to: '/admin',
                            },
                            {
                                text: 'labels.channelspages',
                                to: '/admin/pages/list',
                            },
                            {
                                text: 'labels.channels',
                            },
                        ],
                    },
                },

                /**
                 * Statistics routes
                 */
                {
                    name: 'Dashboard',
                    path: 'dashboard',
                    component: AdminStatisticsBase,
                    redirect: 'dashboard/general',
                    children: [
                        {
                            path: 'general',
                            component: AdminStatisticsGeneral,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.statistics',
                                        to: '/admin/dashboard/general',
                                    },
                                    {
                                        text: 'labels.general',
                                    },
                                ],
                            },
                        },
                        {
                            path: 'revenue',
                            component: AdminStatisticsRevenue,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.statistics',
                                        to: '/admin/dashboard/revenue',
                                    },
                                    {
                                        text: 'labels.revenue',
                                    },
                                ],
                            },
                        },
                        {
                            path: 'check-ins',
                            component: AdminStatisticsCheckins,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.statistics',
                                        to: '/admin/dashboard/check-ins',
                                    },
                                    {
                                        text: 'labels.checkins',
                                    },
                                ],
                            },
                        },
                    ],
                },

                // Access
                {
                    path: 'access',
                    alias: 'doorsnkeys',
                    component: AdminCoDoorsNKeysBase,
                    children: [
                        {
                            name: 'Access',
                            path: '',
                            component: AdminDoorsNKeysMenu,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.access',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Doors',
                            path: 'doors',
                            alias: 'locks',
                            component: AdminAccessLocksList,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.access',
                                        to: '/admin/access',
                                    },
                                    {
                                        text: 'labels.locks',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Policies',
                            path: 'policy',
                            component: AdminAccessPoliciesList,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.access',
                                        to: '/admin/access',
                                    },
                                    {
                                        text: 'labels.policies',
                                    },
                                ],
                            },
                        },
                        {
                            path: 'keys',
                            alias: 'identity',
                            component: AdminAcccesKeyList,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.access',
                                        to: '/admin/access',
                                    },
                                    {
                                        text: 'labels.keys',
                                    },
                                ],
                            },
                        },
                    ],
                },
                // Admin settings
                {
                    path: 'settings',
                    component: AdminSettingsBase,

                    children: [
                        {
                            name: 'SettingsMenu',
                            path: '/',
                            component: AdminSettingsMenu,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Permissions',
                            path: 'permissions',
                            component: AdminSettingsPermissions,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.permissions',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Features',
                            path: 'features',
                            alias: ['/admin/settings/features/bookings', '/admin/settings/features/market'],
                            component: AdminSettingsFeatures,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.features',
                                    },
                                ],
                            },
                        },
                        {
                            // deprecated path, kept as redirect for existing links
                            name: 'AdminFeatureChannels',
                            path: 'features/channels',
                            component: AdminSettingsFeaturesChannels,
                            redirect: '/admin/pages/channels',
                        },
                        {
                            path: 'integrations',
                            component: AdminIntegrationsBase,
                            children: [
                                {
                                    name: 'Zapier',
                                    path: 'zapier',
                                    component: AdminIntegrationsZapier,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.integrations',
                                                to: '/admin/settings/integrations',
                                            },
                                            {
                                                text: 'labels.zapier',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'Google Calendar',
                                    path: 'google-calendar',
                                    component: AdminIntegrationsGoogleCalendar,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.integrations',
                                                to: '/admin/settings/integrations',
                                            },
                                            {
                                                text: 'labels.googlecalendar',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'The Events Calendar',
                                    path: 'theeventcalendar',
                                    component: AdminIntegrationsTheEventCalendar,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.integrations',
                                                to: '/admin/settings/integrations',
                                            },
                                            {
                                                text: 'labels.theeventscalendar',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'Nuki',
                                    path: 'nuki',
                                    component: AdminIntegrationsNuki,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.integrations',
                                                to: '/admin/settings/integrations',
                                            },
                                            {
                                                text: 'labels.nuki',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'Integrations',
                                    path: '',
                                    component: AdminIntegrations,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.integrations',
                                            },
                                        ],
                                    },
                                },
                            ],
                        },

                        {
                            name: 'General settings',
                            path: 'general',
                            component: AdminSettingsGeneral,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.general',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Legal and Compliance',
                            path: 'legal-and-compliance',
                            component: AdminSettingsLegalAndCompliance,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.legalandcompliance',
                                    },
                                ],
                            },
                        },

                        {
                            name: 'PrivacyPolicy',
                            path: 'privacy-policy',
                            component: AdminSettingsPrivacyPolicy,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.privacypolicy',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'TermsAndConditions',
                            path: 'terms-and-conditions',
                            component: AdminSettingsTermsAndConditions,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.termsandconditions',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'AccessibilityPolicy',
                            path: 'accessibility-policy',
                            component: AdminAccessibilityPolicy,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.accessibilitypolicy',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'Customer settings',
                            path: 'customer-number-serttings',
                            component: AdminSettingsMemberSettings,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.customernumbersettings',
                                    },
                                ],
                            },
                        },
                        {
                            path: 'authentications',
                            component: AdminAuthenticationsBase,
                            children: [
                                {
                                    name: 'AuthenticationsMenu',
                                    path: '',
                                    component: AdminAuthentications,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.authentication',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'AuthenticationsSignUp',
                                    path: 'sign-up',
                                    component: AdminAuthenticationsSignUp,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.authentication',
                                                to: '/admin/settings/authentications',
                                            },
                                            {
                                                text: 'labels.signup',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'AuthenticationsLogin',
                                    path: 'login',
                                    component: AdminAuthenticationsLogin,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.authentication',
                                                to: '/admin/settings/authentications',
                                            },
                                            {
                                                text: 'labels.login',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'AuthenticationsIdentityProviders',
                                    path: 'providers',
                                    component: AdminAuthenticationsBase,
                                    children: [
                                        {
                                            path: '',
                                            name: 'AuthenticationsProvidersMenu',
                                            component: AdminAuthenticationsProviders,
                                            meta: {
                                                breadcrumbs: [
                                                    {
                                                        text: 'labels.manage',
                                                        to: '/admin',
                                                    },
                                                    {
                                                        text: 'labels.settings',
                                                        to: '/admin/settings',
                                                    },
                                                    {
                                                        text: 'labels.authentication',
                                                        to: '/admin/settings/authentications',
                                                    },
                                                    {
                                                        text: 'labels.identityproviders',
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            name: 'AuthenticationsProviderCreate',
                                            path: 'create',
                                            component: AdminAuthenticationsProviderEdit,
                                            meta: {
                                                breadcrumbs: [
                                                    {
                                                        text: 'labels.manage',
                                                        to: '/admin',
                                                    },
                                                    {
                                                        text: 'labels.settings',
                                                        to: '/admin/settings',
                                                    },
                                                    {
                                                        text: 'labels.authentication',
                                                        to: '/admin/settings/authentications',
                                                    },
                                                    {
                                                        text: 'labels.identityproviders',
                                                        to: '/admin/settings/authentications/providers',
                                                    },
                                                    {
                                                        text: 'labels.create',
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            name: 'AuthenticationsProviderEdit',
                                            path: ':authMethodID',
                                            component: AdminAuthenticationsProviderEdit,
                                            meta: {
                                                breadcrumbs: [
                                                    {
                                                        text: 'labels.manage',
                                                        to: '/admin',
                                                    },
                                                    {
                                                        text: 'labels.settings',
                                                        to: '/admin/settings',
                                                    },
                                                    {
                                                        text: 'labels.authentication',
                                                        to: '/admin/settings/authentications',
                                                    },
                                                    {
                                                        text: 'labels.identityproviders',
                                                        to: '/admin/settings/authentications/providers',
                                                    },
                                                    {
                                                        text: 'labels.edit',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                // Monetization settings
                {
                    path: 'monetization',
                    component: AdminMonetizationBase,
                    children: [
                        {
                            name: 'MonetizationMenu',
                            path: '/',
                            component: AdminMonetizationMenu,
                            meta: {
                                breadcrumbs: [
                                    {
                                        text: 'labels.manage',
                                        to: '/admin',
                                    },
                                    {
                                        text: 'labels.settings',
                                        to: '/admin/settings',
                                    },
                                    {
                                        text: 'labels.monetization',
                                    },
                                ],
                            },
                        },
                        {
                            path: 'payments',
                            component: AdminPaymentsBase,
                            children: [
                                {
                                    name: 'Payments',
                                    path: '',
                                    component: AdminPayments,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.payments',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'Stripe',
                                    path: 'stripe',
                                    component: AdminPaymentsStripe,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.payments',
                                                to: '/admin/monetization/payments',
                                            },
                                            {
                                                text: 'labels.stripe',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'PaymentMethods',
                                    path: 'payment-methods',
                                    component: AdminPaymentMethods,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.payments',
                                                to: '/admin/monetization/payments',
                                            },
                                            {
                                                text: 'labels.paymentmethods',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'Currency',
                                    path: 'currency',
                                    component: AdminPaymentsCurrency,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.payments',
                                                to: '/admin/monetization/payments',
                                            },
                                            {
                                                text: 'labels.currency',
                                            },
                                        ],
                                    },
                                },
                                {
                                    path: 'tax-rate',
                                    component: AdminTaxRateBase,
                                    children: [
                                        {
                                            name: 'CreateTaxRate',
                                            path: 'create',
                                            component: AdminCreateTaxRate,
                                            meta: {
                                                breadcrumbs: [
                                                    {
                                                        text: 'labels.manage',
                                                        to: '/admin',
                                                    },
                                                    {
                                                        text: 'labels.settings',
                                                        to: '/admin/settings',
                                                    },
                                                    {
                                                        text: 'labels.monetization',
                                                        to: '/admin/monetization',
                                                    },
                                                    {
                                                        text: 'labels.payments',
                                                        to: '/admin/monetization/payments',
                                                    },
                                                    {
                                                        text: 'labels.taxrates',
                                                        to: '/admin/monetization/payments/tax-rate',
                                                    },
                                                    {
                                                        text: 'labels.create',
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            name: 'EditTaxRate',
                                            path: ':ID',
                                            component: AdminEditTaxRate,
                                            meta: {
                                                breadcrumbs: [
                                                    {
                                                        text: 'labels.manage',
                                                        to: '/admin',
                                                    },
                                                    {
                                                        text: 'labels.settings',
                                                        to: '/admin/settings',
                                                    },
                                                    {
                                                        text: 'labels.monetization',
                                                        to: '/admin/monetization',
                                                    },
                                                    {
                                                        text: 'labels.payments',
                                                        to: '/admin/monetization/payments',
                                                    },
                                                    {
                                                        text: 'labels.taxrates',
                                                        to: '/admin/monetization/payments/tax-rate',
                                                    },
                                                    {
                                                        text: 'labels.edit',
                                                    },
                                                ],
                                            },
                                        },
                                        {
                                            name: 'ListTaxRates',
                                            path: '',
                                            component: AdminListTaxRates,
                                            meta: {
                                                breadcrumbs: [
                                                    {
                                                        text: 'labels.manage',
                                                        to: '/admin',
                                                    },
                                                    {
                                                        text: 'labels.settings',
                                                        to: '/admin/settings',
                                                    },
                                                    {
                                                        text: 'labels.monetization',
                                                        to: '/admin/monetization',
                                                    },
                                                    {
                                                        text: 'labels.payments',
                                                        to: '/admin/monetization/payments',
                                                    },
                                                    {
                                                        text: 'labels.taxrates',
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            path: 'plan',
                            component: AdminPlanBase,
                            children: [
                                {
                                    name: 'CreatePlan',
                                    path: 'create',
                                    component: AdminCreatePlan,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.plans',
                                                to: '/admin/monetization/plan',
                                            },
                                            {
                                                text: 'labels.create',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'EditPlan',
                                    path: 'edit/:ID',
                                    alias: ':ID',
                                    component: AdminEditPlan,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.plans',
                                                to: '/admin/monetization/plan',
                                            },
                                            {
                                                text: 'labels.edit',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'ListPlans',
                                    path: '',
                                    component: AdminListPlans,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.plans',
                                                to: '/admin/monetization/plan',
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {
                            path: 'plan-upgrade',
                            component: AdminUpgradesBase,
                            children: [
                                {
                                    name: 'CreatePlanUpgrade',
                                    path: 'create',
                                    component: AdminCreatePlanUpgrade,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.upgrades',
                                                to: '/admin/monetization/plan-upgrade',
                                            },
                                            {
                                                text: 'labels.create',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'EditPlanUpgrade',
                                    path: 'edit/:ID',
                                    component: AdminEditPlanUpgrade,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.upgrades',
                                                to: '/admin/monetization/plan-upgrade',
                                            },
                                            {
                                                text: 'labels.edit',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'ViewPlanUpgrade',
                                    path: ':ID',
                                    component: AdminViewPlanUpgrade,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.upgrades',
                                                to: '/admin/monetization/plan-upgrade',
                                            },
                                            {
                                                text: 'labels.view',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'ListPlanUpgrades',
                                    path: '',
                                    component: AdminListPlanUpgrades,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.upgrades',
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                        {
                            path: 'time-passes',
                            component: AdminTimepassesBase,
                            children: [
                                {
                                    name: 'Timepasses',
                                    path: '',
                                    component: AdminListTimepasses,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.timepasses',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'AdminViewTimepass',
                                    path: 'view/:ID',
                                    component: AdminViewTimepass,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.timepasses',
                                                to: '/admin/monetization/time-passes',
                                            },
                                            {
                                                text: 'labels.view',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'AdminCreateTimepass',
                                    path: 'create',
                                    component: AdminCreateTimepass,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.timepasses',
                                                to: '/admin/monetization/time-passes',
                                            },
                                            {
                                                text: 'labels.create',
                                            },
                                        ],
                                    },
                                },
                                {
                                    name: 'AdminEditTimepass',
                                    path: 'edit/:ID',
                                    component: AdminEditTimepass,
                                    meta: {
                                        breadcrumbs: [
                                            {
                                                text: 'labels.manage',
                                                to: '/admin',
                                            },
                                            {
                                                text: 'labels.settings',
                                                to: '/admin/settings',
                                            },
                                            {
                                                text: 'labels.monetization',
                                                to: '/admin/monetization',
                                            },
                                            {
                                                text: 'labels.timepasses',
                                                to: '/admin/monetization/time-passes',
                                            },
                                            {
                                                text: 'labels.edit',
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    path: '',
                    redirect: 'dashboard',
                },
            ],
        },
        {
            path: '/public',
            component: MainPublic,
            children: [
                {
                    path: 'event/list',
                    name: 'Public Event List',
                    beforeEnter: redirectToEventNotFoundIfDisabled,
                    component: CoViewPublicEventList,
                },
                {
                    path: 'event/:slug',
                    name: 'View Public Event',
                    beforeEnter: redirectToEventNotFoundIfDisabled,
                    component: CoViewPublicEvent,
                },
                {
                    path: 'event-list',
                    name: 'Public Event List',
                    beforeEnter: redirectToEventNotFoundIfDisabled,
                    component: CoViewPublicEventList,
                },
            ],
        },
        {
            path: '/legal',
            name: 'Legal',
            component: MainPublic,
            children: [
                {
                    path: 'privacy-policy',
                    name: 'Privacy Policy',
                    component: PrivacyPolicy,
                },
                {
                    path: 'terms-and-conditions',
                    name: 'Terms and Conditions',
                    component: TermsAndConditions,
                },
                {
                    path: 'accessibility-policy',
                    name: 'Accessibility Policy',
                    component: AccessibilityPolicy,
                },
                // Display the cancellation policy through the same public agreement template.
                {
                    path: 'purchase-cancellation-policy',
                    name: 'Purchase Cancellation Policy',
                    component: PurchaseCancellationPolicy,
                },
                {
                    path: 'right-of-withdrawal',
                    name: 'Right of Withdrawal',
                    component: RightOfWithdrawal,
                },
            ],
        },
        {
            path: '/embed',
            name: 'Embed',
            component: MainEmbed,
            children: [
                {
                    path: 'events',
                    name: 'Embed Event List',
                    component: EmbedEventList,
                },
                {
                    path: 'event/:slug',
                    name: 'Embed Event',
                },
            ],
        },
        {
            path: '/login',
            name: 'Login',
            component: MainPublic,
            children: [
                {
                    path: '',
                    component: Login,
                },
            ],
        },
        {
            path: '/logout',
            name: 'Logout',
            component: MainPublic,
            children: [
                {
                    path: '',
                    component: LogoutAction,
                },
            ],
        },
        {
            path: '/signup',
            name: 'signup',
            alias: '/register',
            component: MainPublic,
            beforeEnter: checkIfAllowedToSingup,
            meta: { hidePublicFooter: true, disablePublicContentTopMargin: true },
            children: [
                {
                    path: '',
                    component: Signup,
                },
            ],
        },
        {
            path: '/reset-password/:code',
            name: 'SetNewPassword',
            component: MainPublic,
            children: [
                {
                    path: '',
                    component: SetNewPassword,
                },
            ],
        },
        {
            path: '/force-password-reset',
            name: 'ForceResetPassword',
            component: ForceResetPassword,
        },
        {
            path: '/reset-password',
            name: 'ResetPassword',
            component: MainPublic,
            children: [
                {
                    path: '',
                    component: ResetPassword,
                },
            ],
        },
        {
            path: '/signup-success',
            name: 'SignUpSuccess',
            component: SignUpSuccess,
        },
        {
            name: 'RegisterV2',
            path: '/registerv2',
            component: RegisterV2,
            beforeEnter: checkIfInviteIsValidForPaid,
        },
        {
            name: 'PlanDetails',
            path: '/plans/:id',
            component: MainPublic,
            beforeEnter: checkIfInviteIsValidForPaid,
            children: [
                {
                    path: '',
                    component: PlanDetails,
                },
            ],
        },
        {
            name: 'Plans',
            path: '/plans',
            component: MainPublic,
            beforeEnter: checkIfInviteIsValidForPaid,
            children: [
                {
                    path: '',
                    component: Plans,
                },
            ],
        },
        {
            path: '/confirm-email/:code',
            name: 'EmailConfirmation',
            component: MainPublic,
            children: [
                {
                    path: '',
                    component: EmailConfirmation,
                },
            ],
        },
        {
            path: '/suspended',
            name: 'Suspended',
            component: Suspended,
            beforeEnter: (to, from, next) => {
                if (store.state.space.Suspended) {
                    next();
                } else {
                    // reject the navigation
                    next('/');
                }
            },
        },
        {
            path: '/permanent-ban',
            name: 'PermanentBan',
            component: PermanentBan,
            beforeEnter: (to, from, next) => {
                if (store.state.space.PermanentBan) {
                    next();
                } else {
                    // reject the navigation
                    next('/');
                }
            },
        },
        {
            path: '/oauth2/exchange',
            name: 'Oauth2ExchangeCode',
            component: OAuth2Callback,
        },
        {
            path: '/oauth2/callback/kickasssquad',
            name: 'Oauth2CallbackKickasssquad',
            // redirect to the exchange page with query params
            beforeEnter: (to, from, next) => {
                next({ name: 'Oauth2ExchangeCode', query: to.query });
            },
        },
        {
            // catch all 404 routing
            // redirect all unresolved urls to dashboard
            path: '*',
            name: 'Catch all',
            beforeEnter: redirectorTo404,
        },
    ],
});

router.beforeEach((to, from, next) => {
    const isAdminRoute = to.path?.startsWith('/admin');
    const isComingFromAdmin = from?.path?.startsWith('/admin');
    const hasNavigatedBefore = Boolean(from && from.name);

    if (isAdminRoute && !isComingFromAdmin && hasNavigatedBefore) {
        // Force a hard navigation when entering /admin from non-admin routes
        window.location.assign(to.fullPath || to.path);
        return;
    }

    next();
});

router.beforeEach((to, from, next) => {
    if (store && store.state.space && store.state.space.Suspended && to.name !== 'AdminAccount') {
        if (
            store.state.me.Permissions &&
            store.state.me.Permissions.includes('space_admin') &&
            to.name !== 'AdminAccount' &&
            to.name !== 'Login'
        ) {
            next({ name: 'AdminAccount' });
        } else if (to.name !== 'Suspended' && to.name !== 'Login') {
            next({ name: 'Suspended' });
        } else {
            next();
        }
    } else if (store && store.state.space && store.state.space.PermanentBan && to.name !== 'PermanentBan') {
        if (to.name !== 'PermanentBan' && to.name !== 'Login') {
            next({ name: 'PermanentBan' });
        } else {
            next();
        }
    } else {
        const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
        const isActiveUser = !store.state.me.Status || store.state.me.Status === 0 || store.state.me.Status === 1;
        const isAccountPath = to.path.includes('account');
        const isMyEventsPath = to.path.includes('/profile/my-events');
        const isEvent = to.name === 'View Event'; // event page will check allowance to fetch it based on backend reply
        // Public event updates use the shared post detail route, so guests need to reach it for the API to decide access.
        const isPostDetail = to.name === 'Single Post View';
        const isGuestAccessibleContent = isEvent || isPostDetail;
        const isNotFoundPage = to.name === 'NotFound'; // allow event 404 redirects for restricted users
        // const isEventList = to.name === 'Events';
        // log all page views
        logPageView(from, to);

        if (
            store.state.me.Status === 7 &&
            requiresAuth &&
            !isAccountPath &&
            !isMyEventsPath &&
            !isGuestAccessibleContent &&
            !isNotFoundPage
        ) {
            if ((to.path === '' || to.path === '/') && !from.path.includes('/event')) {
                next({ name: 'CurrentUserPlanView' });
            }
            EventBus.$emit('GUESTALERT');
        } else if (requiresAuth && !isActiveUser && !isAccountPath && !isMyEventsPath && !isGuestAccessibleContent) {
            // redirect suspended and cancelled users
            next({ name: 'CurrentUserPlanView' });
            EventBus.$emit('ERROR', { Message: 'Your account is not active' });
        } else {
            next();
        }
    }
});
// redirect navigation from /embed routes to open in new tab
router.beforeEach((to, from, next) => {
    if (from.path?.includes('/embed') && !to.path?.includes('/embed')) {
        window.open(to.path, '_blank');
        return; // don't call next() to prevent the navigation
    }
    next();
});

// global handler to open public and legal routes in the browser when clicked from within the mobile app web view
router.beforeEach((to, from, next) => {
    // continue navigation if not in mobile app web view
    if (!store.state.isInMobile) {
        next();
        return;
    }
    // check if navigating to /admin, /public or /legal routes
    const BROWSER_ROUTES = ['/admin', '/public', '/legal'];
    // Keep explicit external targets, such as calendar providers, intact for the native app.
    if (BROWSER_ROUTES.some((route) => to.path?.startsWith(route)) && !to.query?.openinbrowser) {
        const timestamp = Date.now();
        const queryParam = {
            ...to.query,
            m: 'mobile',
            t: String(timestamp),
            openinbrowser: `${to.path}?t=${timestamp}`,
        };
        next({ path: from.path, query: queryParam });
        return;
    }
    next();
});

export default router;
